import axios, { AxiosRequestConfig } from 'axios'
import { AppState } from '@halo/stores/app.state'
import { IApiResponse, IApiCallOptions } from '@pushly/aqe/lib/interfaces'

export const buildApiRequestConfig = (opts: IApiCallOptions | null | undefined, extras?: AxiosRequestConfig): any => {
    return {
        params: opts?.query,
        cancelToken: opts?.cancelToken,
        ...(extras ?? {}),
        headers: {
            ...(extras?.headers ?? {}),
        },
    }
}

export const buildApiResponse = <T extends unknown>(defaults?: { data?: T; meta?: any }): IApiResponse<T> => {
    return {
        ok: false,
        data: defaults?.data ?? undefined,
        meta: defaults?.meta ?? {},
        cancelled: false,
        error: undefined,
    }
}

export const executeApiRequest = async <T extends unknown>(
    method: 'get' | 'post' | 'patch' | 'delete',
    url: string,
    data: any,
    opts: IApiCallOptions | null,
    defaults?: { data?: T; meta?: any },
    extras?: AxiosRequestConfig,
): Promise<IApiResponse<T>> => {
    const svcRes = buildApiResponse(defaults)

    let axiosMethod = axios.get
    const axiosParams: [string, any?] = [url]

    switch (method) {
        case 'post':
            axiosMethod = axios.post
            axiosParams.push(data ?? {})
            break
        case 'patch':
            axiosMethod = axios.patch
            axiosParams.push(data ?? {})
            break
        case 'delete':
            axiosMethod = axios.delete
            break
    }

    axiosParams.push(buildApiRequestConfig(opts, extras))

    try {
        const res = await axiosMethod(...axiosParams)

        const { data: resData, ...resMeta } = res.data

        svcRes.ok = true
        svcRes.data = resData
        svcRes.meta = resMeta.meta ?? resMeta
    } catch (err) {
        svcRes.cancelled = axios.isCancel(err)
        if (!svcRes.cancelled) {
            svcRes.error = err
        }
    }

    return svcRes
}
